import React from 'react';
import styled from 'styled-components';

import InputWithSelectRow from './InputWithSelectRow';
import SlimFormRow from './SlimFormRow';
import InputLabel from '../common/InputLabel';

const InputHeader = styled.label`
    display: inline-block;
    font-size: 1.4em;
    vertical-align: center;
    margin-top: 2em;
    text-align: center;
`;

const NormalSpend = ({ onInputChange, onSelectChange, formData, currency, selectStyles }) => (
    <div>
        <SlimFormRow style={{ display: 'flex', alignItems: 'center' }}>
            <InputLabel style={{ width: '40%' }} />
            <InputHeader style={{ width: '15%', marginRight: '10px' }}>Total Spend</InputHeader>
            <InputHeader style={{ width: '20%', marginRight: '10px' }}>Profit Margin</InputHeader>
            <InputHeader style={{ width: '15%', marginRight: '10px' }}>Nett profit</InputHeader>
        </SlimFormRow>

        <InputWithSelectRow
            title="Normal guest additional spend PRPN"
            grossValue={formData.averageNormalSpend.gross}
            onChangeGrossValue={onInputChange}
            profitMargin={formData.averageNormalSpend.percent}
            onChangeMargin={onSelectChange}
            netProfit={formData.averageNormalSpend.net}
            selectStyles={selectStyles}
            currency={currency}
        />
    </div>
);

export default NormalSpend;
